/* mazo-size-pick.js (2026-10-18, owner, T412): the radios in the "What's my size?" chart pick the size on the product
   page, and the chart follows the size buttons. Nothing is selected until a size is picked; a radio cannot be
   un-picked, same as the size buttons. The chart sits in Dawn's modal-dialog, which moves itself under <body>, so
   everything is looked up from the document, not from the section. */
(function () {
  function sizeInputs() {
    return Array.prototype.filter.call(
      document.querySelectorAll('product-info input[data-option-name="Size" i], product-info .product-form__input--pill input[type="radio"]:not([data-option-name])'),
      function (r) { return !r.closest('.mazo-sizelive') && !r.closest('.mazo-sizechart__units'); }
    );
  }
  function current() {
    var c = sizeInputs().filter(function (r) { return r.checked; })[0];
    return c ? c.value.toLowerCase().trim() : '';
  }
  function sync() {
    var size = current();
    document.querySelectorAll('.mazo-sizechart').forEach(function (chart) {
      chart.setAttribute('data-current-size', size);
      chart.querySelectorAll('input[name="mazo-size-pick"]').forEach(function (r) { r.checked = r.value === size; });
    });
  }
  document.addEventListener('change', function (e) {
    var r = e.target;
    if (!r || r.type !== 'radio') return;
    if (r.name === 'mazo-size-pick') {
      e.stopPropagation();
      var want = r.value;
      var target = sizeInputs().filter(function (i) { return i.value.toLowerCase().trim() === want && !i.disabled; })[0];
      if (target) target.click(); else sync();
      return;
    }
    if (r.closest('product-info')) setTimeout(sync, 0);
  }, true);
  // the whole row is the click target, not just the radio and its label
  document.addEventListener('click', function (e) {
    var tr = e.target.closest && e.target.closest('.mazo-sizechart tr[data-size]');
    if (!tr || e.target.closest('label, input')) return;
    var r = tr.querySelector('input[name="mazo-size-pick"]');
    if (r && !r.checked) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
  });
  // the size buttons are unchecked on load by mazo-size-required.js; sync after it, and after Dawn swaps the picker
  function start() { sync(); setTimeout(sync, 300); }
  if (document.readyState !== 'loading') start(); else document.addEventListener('DOMContentLoaded', start);
  document.addEventListener('shopify:section:load', start);
})();
